import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { EffectiveInstrument } from './effectiveInstrument/EffectiveInstrument';
import { Classifications } from './classifications/Classifications';
import { Strategy } from './strategy/Strategy';
import { MainRecomendations } from './mainRecomendations/MainRecomendations';

import { BREADCRUMBS_DATA } from 'src/constants';

export const Instruments = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.INSTRUMENTS));
  }, [dispatch]);

  return (
    <div className="instruments">
      <EffectiveInstrument />
      <Classifications />
      <Strategy />
      <MainRecomendations />
    </div>
  );
};
